module.exports = __webpack_public_path__ + "38f0f0aca73a664ccfac4d79fd6022e9.png";